var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWarehouse(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39,
    height: 29,
    viewBox: "0 0 39 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.2817 2.67317H26.4129V9.1536H22.2817V2.67317ZM6.24258 2.67317H19.6085V10.2067C19.6085 11.0307 20.0998 11.7458 20.7425 11.7458H27.871C28.4067 11.7458 29.0051 11.1474 29.0051 10.6117V2.67317H34.1894C34.9639 2.67317 35.7286 3.35964 35.7286 4.13127V24.8687C35.7286 25.6403 34.9639 26.3268 34.1894 26.3268H13.7761C11.773 26.3268 12.075 24.2749 12.075 22.9245L12.0589 10.2227C11.9382 9.49805 11.2838 9.1536 10.5359 9.1536H7.61966C5.46973 9.1536 5.6672 11.8268 7.37666 11.8268H9.4828V24.9497C9.4828 26.0747 10.1754 27.3802 10.9857 27.983C12.0254 28.7565 12.7508 29 14.5051 29H33.4604C34.7703 29 36.0462 28.7799 36.9657 27.8879C37.7689 27.1089 38.4017 26.171 38.4017 24.6257V4.3743C38.4017 2.85162 37.7864 1.92683 37.0061 1.15263C36.1945 0.347508 35.0569 0 33.4604 0H6.64759C5.70079 0 5.03171 0.322889 4.92368 1.18598C4.8324 1.91529 5.36648 2.67317 6.24258 2.67317Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.81543 5.83241C0.81543 6.86207 1.55564 7.29051 2.59755 7.29051H9.72603C12.2095 7.29051 11.6988 4.61731 10.1311 4.61731H2.03053C1.41292 4.61731 0.81543 5.31857 0.81543 5.83241L0.81543 5.83241Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.4131 22.5195C26.4131 23.3789 27.0372 23.8966 27.5472 23.8966H31.9215C32.5089 23.8966 33.0555 23.3347 33.0555 22.4385C33.0555 21.9327 32.4273 21.3044 31.9215 21.3044H27.6282C26.9366 21.3044 26.4131 21.8279 26.4131 22.5195V22.5195Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarehouse);
export default __webpack_public_path__ + "static/media/warehouse.4303a7ea154fe419d34b2b67d1e62f35.svg";
export { ForwardRef as ReactComponent };